// Taken from ctrl-v-website/utils/GlobalConsts
export const APIPath = () =>{
    console.log(process.env);
    return process.env.REACT_APP_API_URL;
}
export const getExtension = () => {
    var ua = navigator.userAgent.toLowerCase(); 
    let isSafari = false;
    if (ua.indexOf('safari') !== -1) { 
        if (ua.indexOf('chrome') > -1) {
            isSafari = false;
            //alert("1") // Chrome
    } else {
            isSafari = true;
            //alert("2") // Safari
        }
    }
    //const isSafari = /constructor/i.test(window.HTMLElement) || 
    //(function (p) { return p.toString() === "[object SafariRemoteNotification]"; })
    //(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    if(isSafari) return 'png'
    else return 'webp'
}